export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  email: {
    value: null,
    maxlength: '70',
    required: false,
    state: null
  },
  cellPhone: {
    value: null,
    maxlength: '20',
    required: true,
    state: null
  },
  oldpassword: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  password: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  confirmation: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/myaccount/profile/profile-form.js